import { render, staticRenderFns } from "./BitrixFieldMappingRow.vue?vue&type=template&id=4fe79f40&scoped=true"
import script from "./BitrixFieldMappingRow.vue?vue&type=script&lang=js"
export * from "./BitrixFieldMappingRow.vue?vue&type=script&lang=js"
import style0 from "./BitrixFieldMappingRow.vue?vue&type=style&index=0&id=4fe79f40&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe79f40",
  null
  
)

export default component.exports